var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PEC_card1"},[_c('div',{staticClass:"PEC_card_img"},[_c('img',{attrs:{"src":_vm.$hdAddress + _vm.imgsUrls[0],"alt":""}})]),_c('div',{staticClass:"PEC_card_text"},[_c('span',[_vm._v(_vm._s(this.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }